<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="6">
          <div>
            <h3 class="title mb-3">Capture Feed</h3>
            <!-- <v-divider></v-divider> -->
          </div>
          <div class="d-flex align-center">
            <v-btn-toggle v-model="toggle_one" mandatory>
              <v-btn>
                RGB
              </v-btn>
              <v-btn>
                THERMAL
              </v-btn>
              <v-btn>
                IR
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <div>
              <v-icon color="primary" small left>mdi-record-circle</v-icon>
              <span class="body-1">Recording</span>
            </div>
          </div>
          <v-img
            height="350"
            cover
            :src="require('./../assets/'+images[toggle_one])"
            >
            <!-- src="http://127.0.0.1:8000/stream" -->
            <div class="ma-3">
              <v-icon small color="green">
                mdi-circle
              </v-icon> <strong class="overline">
                LIVE (MAIN CAM)
              </strong>
            </div>
          </v-img>
        </v-col>
        <v-col cols="6">
          <div class="mx-3">
            <h3 class="title">Monitoring</h3>
            <!-- <v-divider></v-divider> -->
          </div>
          <div>
            <v-row no-gutters>
              <v-col md="6">
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-eye</v-icon>  
                      <span>DETECTIONS</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      02
                    </h5> <span>From 10:00 - ~</span>
                    <div class="mt-2 body-2">Last event at 09:05 <v-btn class="inline-block ml-3" small outlined
                        color="primary">CHECK</v-btn> </div>
                  </v-card-text>
                </v-card>
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-crosshairs-gps</v-icon>  
                      <span>POSITION</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      10°N 30°E
                    </h5>
                  </v-card-text>
                </v-card>
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-thermometer</v-icon>  
                      <span>CORE TEMPERATURE</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      67°
                    </h5> <span>Celsius</span>
                  </v-card-text>
                </v-card>
                <!-- <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline">BATTERY</h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      78
                    </h5> <span>Percent</span>
                    <div class="mt-2 body-2">Next charge checkpoint in 20 mins</div>
                  </v-card-text>
                </v-card> -->
              </v-col>
              <v-col md="6">
                <v-card class="ma-3 pb-2" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-battery</v-icon>  
                      <span>BATTERY</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      78
                    </h5> <span>Percent</span>
                    <div class="mt-2 body-2">Next charge checkpoint in 20 mins</div>
                  </v-card-text>
                </v-card>
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-speedometer</v-icon>  
                      <span>SPEED</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      15
                    </h5> <span>mph</span>
                  </v-card-text>
                </v-card>
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-weight</v-icon>  
                      <span>PAYLOAD</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      18
                    </h5> <span>kg</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col md="6">
          <h3 class="title">Tunnel Probability</h3>
          <div>
            <Graph />
          </div>
        </v-col>
        <v-col md="6">
          <div class="mx-3">
            <h3 class="title">Actions</h3>
            <div>
              <v-switch v-model="isMicActive" inset label="Mic On"></v-switch>
              <v-btn @click="micDialogOpen = true" :disabled="!isMicActive">START BROADCAST</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="micDialogOpen" height="" width="500">
        <v-card>
          <div class="text-center pt-10">
            <v-icon color="primary" x-large>
              mdi-microphone
            </v-icon>
          </div>
          <v-card-title class="headline justify-center">
            Secure Broadcast Started
          </v-card-title>
          <v-card-text class="text-center">
            <h4 class="subtitle-2">
              Start speaking into the mic
            </h4>
            <div class="text-center">
              <v-icon x-large>mdi-dots-horizontal</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    
  </div>
</template>

<script>
import Graph from './../components/Graph.vue'

export default {
  data: () => ({
    toggle_one: 0,
    isMicActive: false,
    micDialogOpen: false,
    images: ['detection_03.jpg', 'detection_03_thermal.jpg', 'detection_03_IR.jpg']
  }),
  components: {
    Graph
  }
}
</script>